import queryKeys from '@/constants/queryKeys';
import { teamConcernsGet } from '@/services/api/requests/organization';
import { TTeamConcernsRange } from '@/types/Organization.types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

const useTeamConcerns = (range: TTeamConcernsRange) => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.organization.teamConcerns, range],
    placeholderData: keepPreviousData,
    queryFn: () => teamConcernsGet(range),
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useTeamConcerns;
